// eslint-disable-next-line no-unused-vars
import { Fancybox } from '@fancyapps/ui';
import Faqs from '../../../frontend/blocks/faqs/faqs.js';
import HeaderScroll from './components/HeaderScroll.js';
import MobileMenu from './components/MobileMenu.js';
import Toggle from './components/Toggle.js';
import FooterToggle from './components/FooterToggle.js';
import Tabs from './components/Tabs.js';
import GformUpload from './components/GformUpload.js';
import SmoothScroll from './components/SmoothScroll.js';
import NumberCounter from './components/NumberCounter.js';
import GeneralHero from '../../../frontend/blocks/general-hero/general-hero.js';
import ImageGalleryVideoSlider from '../../../frontend/blocks/image-gallery-video/image-gallery-video';
import '../../../node_modules/vanilla-cookieconsent/dist/cookieconsent.js';
import MediaTextarea from '../../../frontend/blocks/media-textarea/media-textarea';
import Testimonials from '../../../frontend/blocks/testimonials/testimonials.js';
import PopupSearch from './components/PopupSearch.js';
import Animate from './components/Animate.js';
import MediaColumns from '../../../frontend/blocks/media-columns/media-columns.js';
import GFormStyling from './components/GFormStyling.js';
import CustomSearch from './components/CustomSearch.js';
import SwiperGallery from './components/SwiperGallery.js';
import EmailObfuscate from './components/EmailObfuscate.js';

// Set to true so we don't include the js in the build
const stackMediaColumns = true;

{
    Animate();
}

{
    const emailObfuscate = document.querySelector('.js-obfuscated-email');

    if (typeof emailObfuscate != 'undefined' && emailObfuscate != null) {
        EmailObfuscate();
    }
}

{
    const swiperGallery = document.querySelector('.swiper');

    if (typeof swiperGallery != 'undefined' && swiperGallery != null) {
        SwiperGallery();
    }
}

{
    const customSearch = document.querySelector('.search-form');

    if (typeof customSearch != 'undefined' && customSearch != null) {
        CustomSearch();
    }
}

{
    const gFormStyling = document.querySelector('.gform_wrapper');

    if (typeof gFormStyling != 'undefined' && gFormStyling != null) {
        GFormStyling();
    }
}

{
    const numberCounter = document.querySelector('.js-count-up');
    if (typeof numberCounter != 'undefined' && numberCounter != null) {
        NumberCounter();
    }
}

{
    const mediaTextarea = document.querySelector('.media-textarea__swiper');

    if (typeof mediaTextarea != 'undefined' && mediaTextarea != null) {
        MediaTextarea();
    }
}

// only include if stackMediaColumns is set to false
if (!stackMediaColumns) {
    {
        const mediaColumns = document.querySelector('.media-columns__swiper');

        if (typeof mediaColumns != 'undefined' && mediaColumns != null) {
            MediaColumns();
        }
    }
}

{
    const header = document.querySelector('.header');

    if (typeof header != 'undefined' && header) {
        HeaderScroll();
    }
}

{
    const faqs = document.querySelector('[data-question]');

    if (typeof faqs != 'undefined' && faqs) {
        Faqs();
    }
}

{
    const mobile_menu = document.querySelector('.mobile-menu');

    if (typeof mobile_menu != 'undefined' && mobile_menu) {
        MobileMenu();
    }
}

{
    const toggle_element = document.querySelector('[data-toggle]');

    if (typeof toggle_element != 'undefined' && toggle_element) {
        Toggle();
    }
}

{
    const footer_toggle = document.querySelector('[data-footer-toggle]');

    if (typeof footer_toggle != 'undefined' && footer_toggle) {
        FooterToggle();
    }
}

{
    const tabs = document.querySelector('[data-tabs]');

    if (typeof tabs != 'undefined' && tabs != null) {
        Tabs();
    }
}

{
    // eslint-disable-next-line no-undef
    if (typeof gform != 'undefined' && gform != null) {
        GformUpload();
    }
}

{
    const anchorLink = document.querySelector('[data-smooth-scroll]');

    if (typeof anchorLink != 'undefined' && anchorLink != null) {
        SmoothScroll(anchorLink);
    }
}

{
    const generalHero = document.querySelector('.hero__swiper');
    if (typeof generalHero != 'undefined' && generalHero != null) {
        GeneralHero(generalHero);
    }
}

{
    const imageGalleryVideoSlider = document.querySelector('.image-gallery-video__swiper-wrapper');

    if (typeof imageGalleryVideoSlider != 'undefined' && imageGalleryVideoSlider != null) {
        ImageGalleryVideoSlider(imageGalleryVideoSlider);
    }
}

{
    const testimonials = document.querySelector('.testimonials__swiper');
    if (typeof testimonials != 'undefined' && testimonials != null) {
        Testimonials(testimonials);
    }
}

{
    const popupSearch = document.querySelector('[data-popup-search]');

    if (typeof popupSearch != 'undefined' && popupSearch != null) {
        PopupSearch(popupSearch);
    }
}
